import { Action, createReducer, on } from '@ngrx/store';
import {
    loadAvailableCerts,
    loadAvailableCertsSuccess,
    loadAvailableSkills,
    loadAvailableSkillsSuccess,
    loadQualifications,
    loadQualificationsSuccess,
    loadQualificationChanges,
    loadQualificationChangesSuccess,
    resetQualificationChanges,
    getRequirementsFromUD,
    getRequirementsFromUDSuccess,
    loadClinicalTrackCerts,
    loadClinicalTrackCertsSuccess,
    loadClinicalTrackSkills,
    loadClinicalTrackSkillsSuccess
} from '../actions/job-qualifications.actions';
import { JobQualificationsState } from '../state/job-qualifications.state';

const initialState: JobQualificationsState = {
    jobId: 0,
    qualifications: undefined,
    availableSkills: [],
    availableCerts: [],
    clinicalTrackCerts: [],
    clinicalTrackSkills: [],
    changes: undefined,
    sideDrawerLoading: false,
    isLoading: false,
    isChangesLoading: false
};

const reducer = createReducer(
    initialState,

    on(
        loadQualifications,
        (state): JobQualificationsState => ({
            ...state,
            isLoading: true
        })
    ),

    on(
        loadQualificationsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            isLoading: false,
            qualifications: action.qualifications
        })
    ),

    on(
        loadQualificationChanges,
        (state): JobQualificationsState => ({
            ...state,
            isChangesLoading: true
        })
    ),

    on(
        loadQualificationChangesSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            isChangesLoading: false,
            changes: action.changes
        })
    ),

    on(
        resetQualificationChanges,
        (state): JobQualificationsState => ({
            ...state,
            changes: undefined
        })
    ),

    on(
        loadAvailableSkills,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: true
        })
    ),

    on(
        loadAvailableSkillsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false,
            availableSkills: action.skills
        })
    ),

    on(
        loadAvailableCerts,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: true
        })
    ),

    on(
        loadAvailableCertsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false,
            availableCerts: action.certs
        })
    ),

    on(
        loadClinicalTrackCerts,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: true
        })
    ),

    on(
        loadClinicalTrackCertsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false,
            clinicalTrackCerts: action.certs
        })
    ),

    on(
        loadClinicalTrackSkills,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: true
        })
    ),

    on(
        loadClinicalTrackSkillsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false,
            clinicalTrackSkills: action.skills
        })
    ),

    on(
        getRequirementsFromUD,
        (state): JobQualificationsState => ({
            ...state,
            isLoading: true
        })
    ),

    on(
        getRequirementsFromUDSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            isLoading: false,
            qualifications: action.qualifications
        })
    )
);

export function jobQualificationsReducer(state: JobQualificationsState | undefined, action: Action) {
    return reducer(state, action);
}
